module.exports = __webpack_public_path__ + "img/logo4@2x.57145390.png";